import React, { useState } from "react";
import { GET_STANDS_CURSOR } from "graphql/query/stand-gql";
import { PageWrapDefault, Tables } from "components/layout";
import { Localize } from "components/service";
import { useActiveMenuItem, useBreadCrumbs } from "components/use-hooks";
import StandsGlobal from "components/stands-global";
import { gqlBuilderWhere } from 'utils';


const routeUrl = StandsGlobal.Const.basePath;
const filterTable = 'table-stands-global';
const objOrderBy = [
    { column: "EE_ID", order: "DESC" },
    { column: "ID", order: "DESC" }
];
const legacyObjOrderBy = [ { column: "ID", order: "DESC" } ];

const isSameSorting = (current, target) => JSON.stringify(current) === JSON.stringify(target);

const StandsGlobalPage = () => {

    useActiveMenuItem([ "stands-global" ], [ "stands-global" ]);

    const breadcrumbs = [
        {
            label: Localize({ children: "BREADCRUMBS.Label_GlobalStandSearch" }).props.children,
            path: routeUrl
        }
    ];

    useBreadCrumbs(breadcrumbs);

    const standsGlobalFilters = JSON.parse(localStorage.getItem(`standsGlobalFilters-${ filterTable }`));
    const storedStandsGlobalSorting = JSON.parse(localStorage.getItem(`standsGlobalSorting-${ filterTable }`));
    const standsGlobalSorting = isSameSorting(storedStandsGlobalSorting, legacyObjOrderBy) ? false : storedStandsGlobalSorting;
    const standsGlobalSearch = JSON.parse(localStorage.getItem(`standsGlobalSearch-${ filterTable }`));

    const [ searchText, setSearchText ] = useState(standsGlobalSearch);
    const [ filters, setFilters ] = useState(gqlBuilderWhere(standsGlobalFilters));
    const [ resetSorting, setResetSorting ] = useState(false);

    return (
        <PageWrapDefault
            className="page-stands-global"
            dataExist={ true }
            title={ <Localize>PAGES.Title_GlobalStandSearch</Localize> }
        >
            <Tables.Cursor
                extraClass="table-stands-global"
                tableLayout=""
                model="standsCursor"
                query={ GET_STANDS_CURSOR }
                varSet={ {
                    perPage: 100,
                } }
                routeUrl={ routeUrl }
                searchText={ searchText }
                objFilter={ filters }
                objOrderBy={ standsGlobalSorting || objOrderBy }
                sortingName={ `standsGlobalSorting-${ filterTable }` }
                tableHelper={ StandsGlobal.Helpers.TableMain }
                resetSorting={ resetSorting }
                filterTable={ filterTable }
            >
                <div className="table-action-bar">
                    <div className="col">
                        <StandsGlobal.Filters.Table
                            setSearchText={ setSearchText }
                            searchText={ searchText }
                            setFilters={ setFilters }
                            filters={ filters }
                            standsGlobalFilters={ standsGlobalFilters }
                            setResetSorting={ setResetSorting }
                            objOrderBy={ objOrderBy }
                            filterTable={ filterTable }
                        />
                    </div>
                    <div className="col">
                    </div>
                </div>
            </Tables.Cursor>
        </PageWrapDefault>
    );
};

export default StandsGlobalPage;
